<mat-sidenav-container class="mainWrapper" autosize autoFocus [ngClass]="{
  'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' &&  !resView,  
  'sidebarNav-horizontal': options.horizontal,
  cardBorder: options.cardBorder,  
}" [dir]="options.dir!">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  @if (!options.horizontal) {
  <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="
      options.navPos === 'side' && options.sidenavOpened && !isOver && !resView
    " (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
      <ng-scrollbar class="sidebar-cust position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
      <!--<div class="p-24 m-t-auto profile-bar">
        <div class="bg-light-primary d-flex align-items-center rounded p-16 ">
          <div class="rounded-circle object-cover avatartop   text-center"
               width="40"> {{ this.authService.userFullName?.charAt(0).toUpperCase() }}</div>
          <div class="m-l-16">
            <h4 class="f-w-600">{{this.authService.userFullName}}</h4>
          </div>
          <div class="m-l-auto">
            <a mat-icon-button (click)="logout()" class="d-flex justify-content-center">
              <i-tabler name="power" class="text-primary icon-18 d-flex"></i-tabler>
            </a>
          </div>
        </div>

        
      </div>-->
    </div>
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- horizontal Sidebar -->
  <!-- ============================================================== -->
  @if (resView) {
  <mat-sidenav #leftsidenav [mode]="'over'" [opened]="options.sidenavOpened && !isTablet"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver">
    </app-sidebar>
    <ng-scrollbar class="position-relative" style="height: 100%">
      <mat-nav-list class="sidebar-list">
        @for(item of navItems; track item) {
        <app-nav-item [item]="item" (notify)="sidenav.toggle()"> </app-nav-item>
        }
      </mat-nav-list>
    </ng-scrollbar>
    <div class="p-24 m-t-auto profile-bar">
      <div class="bg-light-primary d-flex align-items-center rounded p-24">
        <img src="/assets/images/profile/user-1.jpg" class="rounded-circle" width="40" />
        <div class="m-l-16">
          <h4 class="f-w-600">Mike</h4>
          <span class="f-s-12">Admin</span>
        </div>
        <div class="m-l-auto">
          <a mat-icon-button [routerLink]="['/authentication/login']" class="d-flex justify-content-center">
            <i-tabler name="power" class="text-primary icon-18 d-flex"></i-tabler>
          </a>
        </div>
      </div>
    </div>
  </mat-sidenav>
  }
  
  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper res-pad" [ngClass]="{ 'p-l-0 p-r-24': !options.horizontal }" #content><!--UI change ned to heckin-->
    <!-- horizontal header -->
    @if(options.horizontal) {
    <app-horizontal-header (toggleMobileNav)="sidenav.toggle()" (toggleMobileFilterNav)="filterNavRight.toggle()"
                           (optionsChange)="receiveOptions($event)"></app-horizontal-header>
    } @if(options.horizontal) {
    <ng-container>
      <app-horizontal-sidebar></app-horizontal-sidebar>
    </ng-container>
    }

    <main class="" [ngClass]=" ShowRenew ? 'pageNotesWrapper' : 'pageWrapper' ">
      @if(!options.horizontal) {
      <ng-container>
        <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()" (toggleMobileNav)="sidenav.toggle()"
                    (toggleMobileFilterNav)="filterNavRight.toggle()" (optionsChange)="receiveOptions($event)"></app-header>
      </ng-container>
      }
      <!--<div class="m-t-30" [ngClass]="{ 'p-l-24 p-r-24': options.horizontal }">-->
      <div style="margin-top:76px;" [ngClass]="{ 'p-l-24 p-r-24': options.horizontal }">
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>


      </div>
      <div class="customizerBtn">
        <button mat-fab class="bg-primary text-white" (click)="customizerRight.toggle()">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </main>


    <mat-card class="bg-none b-0 p-0 f-s-12 footer m-b-0" style="margin-bottom:0px !important; position:relative;bottom:0px">
      <div *ngIf="this.ShowRenew" class="container-fluid ps-0 mt-3  pb-2 ">
        <div class="col-md-12 sub-blk text-center">
          @if(this.leftDays >= 1){
          <a id="traildaysID"> Your software licence will expire in {{this.leftDays > 1 ? this.leftDays + ' days' : this.leftDays + ' day'}} </a>
          }
          @else if(this.leftDays == 0){
          <a id="traildaysID"> Your software licence expires Today</a>
          }@else{
          <a id="traildaysID"> Your software licence is expired</a>
          }
          <!--<a id="subscribeRenewBtn" [disabled]="!IsAdmin" class="UserPlans btn-expire" (click)="Upgrade('Renew')">Renew</a>-->
          <a id="subscribeRenewBtn"
             [style.pointer-events]="IsAdmin ? 'auto' : 'none'"
             [style.opacity]="IsAdmin ? '1' : '0.6'"
             [style.cursor]="IsAdmin ? 'pointer' : 'not-allowed'"
             class="UserPlans btn-expire"
             (click)="IsAdmin && Upgrade('Renew')">
            Renew
          </a>
        </div>
      </div>
      <div class="row p-0 text-black-25 text-center">
        <div class="col-12 col-sm-7 col-md-7 col-xxl-7">
          <div class="float-start text-left fw-bold text-dark">
            Copyright © <a href="https://andica.com/" target="_blank" style="color: #ff6600; font-weight: bold;"> 2004-{{nextyear}} Andica Limited.</a> All rights reserved.
          </div>
        </div>
        <div class="col-12 col-sm-5 col-md-5 col-xxl-5">
          <div class="text-right text-md-end">
            <a href="https://www.andica.com/legal-software-licence-agreement.html" target="_blank" class="fw-bold " style="color: #ff6600;">Licence Agreement</a> <span class="m-x-5 " style="font-size:18px !important">.</span>
            <a href="https://www.andica.com/legal.html" target="_blank" class="fw-bold" style="color: #ff6600; ">Legal Terms</a>
          </div>
        </div>
      </div>
    </mat-card>
  </mat-sidenav-content>

  <mat-sidenav #customizerRight mode="over" position="end" class="customizerNav">
    <div class="p-x-16 p-y-20 d-flex align-items-center justify-content-between">
      <h3 class="f-s-21 f-w-600">Settings</h3>

      <button class="d-lg-none" mat-button (click)="customizerRight.toggle()">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
      </button>
    </div>

    <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
  </mat-sidenav>
</mat-sidenav-container>

<!-- ------------------------------------------------------------------
  Mobile Apps Sidebar
  ------------------------------------------------------------------ -->
<mat-drawer #filterNavRight mode="over" position="end" class="filter-sidebar">
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="branding">
        <app-branding></app-branding>
      </div>
      <button mat-icon-button (click)="filterNavRight.toggle()" class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>

    <mat-accordion>
      <mat-expansion-panel class="shadow-none">
        <mat-expansion-panel-header>
          <mat-panel-title class="f-s-16 f-w-500"> Apps </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row">
            @for(appdd of apps; track appdd.img) {
            <div class="col-12 text-hover-primary">
              <a [routerLink]="[appdd.link]" class="d-flex align-items-center text-decoration-none m-b-24 gap-16">
                <button mat-mini-fab class="text-primary bg-light shadow-none rounded">
                  <img [src]="appdd.img" width="20" />
                </button>

                <div>
                  <h5 class="f-s-14 f-w-600 m-0 textprimary hover-text">
                    {{ appdd.title }}
                  </h5>
                  <span class="f-s-12">{{ appdd.subtitle }}</span>
                </div>
              </a>
            </div>
            }
          </div>
          <h4 class="f-s-18 f-w-600 m-b-16">Quick Links</h4>
          @for(quicklink of quicklinks; track quicklink.title) {
          <div class="text-hover-primary">
            <a [routerLink]="['quicklink.link']" class="hover-text text-decoration-none f-w-600 d-block p-y-8">{{
              quicklink.title }}</a>
          </div>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="p-x-24">
      <a [routerLink]="['/apps/calendar']" class="d-flex align-items-center text-decoration-none p-y-16 gap-8">
        <span class="f-s-15 f-w-500 m-l-8">Calendar</span>
      </a>
      <a [routerLink]="['/apps/chat']" class="d-flex align-items-center text-decoration-none p-y-16">
        <span class="f-s-15 f-w-500 m-l-8">Chat</span>
      </a>
      <a [routerLink]="['/apps/email/inbox']" class="d-flex align-items-center text-decoration-none p-y-16 gap-8">
        <span class="f-s-15 f-w-500 m-l-8">Email</span>
      </a>
    </div>
  </div>
</mat-drawer>
